import { FORM_MODIFIER } from '../../../form/model/form.modifier';
import { ModifiersZTableModel } from '../table.modifier';
import { TTableTreeModel } from '../table.type';

export const TASK_EDIT_TABLE = {
  addFeatureEdit: <T>(tableModel: TTableTreeModel<T>): TTableTreeModel<T> => {
    if (tableModel.options?.isViewOnly) {
      return tableModel;
    }
    const { header, rows } = tableModel.tableInfo;
    const hasCellWithLiftedInput = header.cells.find((c) => c.liftedInput);
    if (hasCellWithLiftedInput) {
      return {
        ...tableModel,
        tableInfo: {
          ...tableModel.tableInfo,
          header: {
            ...header,
            cells: [
              ...header.cells,
              {
                type: 'EDIT_ROW',
                hasAddRow: tableModel.options?.edit?.hasAddRow || false,
                // isEditing: false, ??? [NOTE] Anubhav check why was this removed
                widthInPx: 100,
                ...(tableModel.options?.edit?.stickyType && {
                  stickyType: tableModel.options?.edit?.stickyType,
                  stickyPosition: 0,
                }),
              },
            ],
          },
          rows: rows.map((r) => ({
            ...r,
            cells: [
              ...r.cells,
              {
                type: 'EDIT_ROW',
                isMulti: tableModel.options?.edit?.isMulti || false,
                hasDeleteRow: tableModel.options?.edit?.hasDeleteRow || false,
              },
            ],
          })),
        },
        hasEditableInput: !!hasCellWithLiftedInput,
      };
    }
    return tableModel;
  },
  removeAddRow: <T>(tableModel: TTableTreeModel<T>): TTableTreeModel<T> => {
    const isMultiEdit = tableModel.options?.edit?.isMulti || false;
    const isNotMultiEdit = !isMultiEdit;
    return {
      ...tableModel,
      tableInfo: {
        ...tableModel.tableInfo,
        rows: isNotMultiEdit
          ? tableModel.tableInfo.rows.filter((v) => v.type !== 'ADD_ROW')
          : [...tableModel.tableInfo.rows],
      },
    };
  },

  setNoEditsInEditMode: <T>(tableModel: TTableTreeModel<T>): TTableTreeModel<T> => {
    const { rows } = tableModel.tableInfo;
    if (rows.length === 0) return tableModel;

    const updatedRows = rows.map((v) => {
      switch (v.type) {
        case 'EDIT_ROW':
          return {
            ...v,
            ...(!!v.formModel && {
              formModel: FORM_MODIFIER.setNoEditsInEditMode(v.rowItem, v.formModel.inputs),
            }),
          };
        default:
          return v;
      }
    });
    return {
      ...tableModel,
      tableInfo: {
        ...tableModel.tableInfo,
        rows: updatedRows,
      },
    };
  },
  isEditOnly: <T>(tableModel: TTableTreeModel<T>): TTableTreeModel<T> => {
    const isMultiEdit = tableModel.options?.edit?.isEditOnly || false;
    const isNotMultiEdit = !isMultiEdit;
    if (isNotMultiEdit) return tableModel;

    return ModifiersZTableModel.editRowByIndex({
      ...tableModel,
    });
  },
};
